import React, { VFC } from 'react';
import { Box, makeStyles, Typography, useTheme } from '@dxb-web-ui-framework/design-system';
import EcommbxLogoDesktop from '../../../../../../channels/secure-web/assets/static/images/ic-logo-ecommbx.svg';

type ResidentBankLogoProps = {
  resident: string;
};

const useStyles = makeStyles(theme => ({
  alternativeBank: {
    backgroundColor: theme.palette.grey[200],
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));

const ResidentBankLogo: VFC<ResidentBankLogoProps> = ({ resident }) => {
  const theme = useTheme();
  const classes = useStyles();
  const isEcommBX = resident === 'EcommBX';

  return (
    <>
      {isEcommBX ? (
        <Box>
          <Typography variant={'srOnly'}>{'Ecommbx'}</Typography>
          <img src={EcommbxLogoDesktop} alt={'Ecommbx'} height={theme.spacing(3)} width={83} aria-hidden={true} />
        </Box>
      ) : (
        <Box className={classes.alternativeBank}>
          <Typography variant={'body2'}>{resident}</Typography>
        </Box>
      )}
    </>
  );
};

export { ResidentBankLogo };
